import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import NodeIcon from '../../components/NodeIcon';
import NodeHeader from '../NodeHeader';
import NodeWrapper from '../NodeWrapper';

import type { ForwardType } from './ForwardControls';
import type { NodeProps } from '@xyflow/react';

/**
 * Renders a forward node component.
 *
 * @return {React.ReactElement} The JSX element representing the forward node component.
 */
export default function ForwardNode({ data }: NodeProps & { data: ForwardType }): React.ReactElement {
  const translate = useTranslate();

  const numberInvalid = data?.number === undefined || data.number === '';

  const errors = numberInvalid ? ['callflows.nodes.forward.forwardErrorEmpty'] : [];

  return (
    <NodeWrapper errors={errors}>
      <NodeHeader icon={<NodeIcon name='forward' />} title={translate('callflows.nodes.forward.name')} />
      <Handle type='target' position={Position.Left} id='forward-target' />
    </NodeWrapper>
  );
}
